import styles from '../TravelExpensesOverlayController.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@work4all/components/lib/dataDisplay/card';

import { BusinessPartnerPickerField } from '../../../../../../components/entity-picker/BusinessPartnerPickerField';
import { CostCenterPickerField } from '../../../../../../components/entity-picker/CostCenterPickerField';
import { ProjectPickerField } from '../../../../../../components/entity-picker/ProjectPickerField';
import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import { Collapse, ControlWrapper } from '../../../components';
import { TravelExpensesFormValue } from '../type';

export const Assignment = () => {
  const { t } = useTranslation();

  const form = useFormContextPlus<TravelExpensesFormValue>();
  const { control } = form;

  return (
    <Collapse title={t('MASK.ASSIGNMENT')} defaultOpen>
      <Card>
        <ControlWrapper className={styles.assignmentControls}>
          <ControllerPlus
            control={control}
            name="visitedContact"
            render={({ field }) => (
              <BusinessPartnerPickerField
                {...field}
                value={field.value?.data}
              />
            )}
          />

          <ControllerPlus
            control={control}
            name="project"
            render={({ field }) => (
              <ProjectPickerField label={t('INPUTS.PROJECT')} {...field} />
            )}
          />

          <ControllerPlus
            control={control}
            name="costCenter"
            render={({ field }) => (
              <CostCenterPickerField
                label={t('INPUTS.COST_CENTRE')}
                {...field}
              />
            )}
          />
        </ControlWrapper>
      </Card>
    </Collapse>
  );
};
